import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { PromoEntity } from './promo.entity';
import { ShippingMethodEntity } from './shipping-method.entity';

// Restricts a SHIPPING-class promo to specific shipping methods. If no rows
// exist for the promo, it applies to ALL methods (the default behavior).
@Index('promo_shipping_method_pk', ['fkPromoId', 'fkShippingMethodId'], {
	unique: true,
})
@Entity('promo_shipping_method')
export class PromoShippingMethodEntity extends BaseEntity {
	@Column('int', { name: 'fk_promo__id', unsigned: true })
	public fkPromoId!: number;

	@Column('int', { name: 'fk_shipping_method__id', unsigned: true })
	public fkShippingMethodId!: number;

	@ManyToOne(() => PromoEntity, (promo) => promo.promoShippingMethods, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_promo__id', referencedColumnName: 'id' }])
	public fkPromo!: PromoEntity;

	@ManyToOne(() => ShippingMethodEntity, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_shipping_method__id', referencedColumnName: 'id' }])
	public fkShippingMethod!: ShippingMethodEntity;
}
